import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { PAINTING_SERVICES } from "@/data/site";
import { Icon } from "@/lib/Icon";
import { Reveal } from "@/lib/motionPrimitives";

export default function PaintingServices() {
  return (
    <section id="painting" className="relative py-24 md:py-32" data-testid="painting-services">
      <div className="container-x">
        <Reveal>
          <p className="overline">Painting Solutions</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Interior &amp; Exterior Painting
          </h2>
          <p className="mt-4 max-w-xl text-muted-foreground">
            Beyond industrial coatings, we deliver clean interior finishes and durable exterior painting for every structure.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-2">
          {PAINTING_SERVICES.map((s, i) => (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`painting-card-${s.title}`}
              className="group relative overflow-hidden rounded-3xl border border-border bg-surface"
            >
              <div className="relative h-64 overflow-hidden md:h-72">
                <img
                  src={`${s.image}?auto=format&fit=crop&w=1200&q=75`}
                  alt={s.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute left-6 top-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
                  <Icon name={s.icon} className="h-6 w-6" />
                </div>
                <h3 className="absolute bottom-5 left-6 font-display text-2xl font-bold text-white">{s.title}</h3>
              </div>

              <div className="p-7 md:p-8">
                <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
                <ul className="mt-5 grid gap-2.5">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-sm font-medium">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                        <Check className="h-3.5 w-3.5" />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary"
                  data-testid={`painting-quote-${s.title}`}
                >
                  Request a Quote
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
